import React from 'react';
import { apiRoutes } from 'api_routes/api_routes';
import AuthTemplate from 'templates/AuthTemplate';
import LoginStandard from 'components/molecules/Login/LoginStandard';

const LoginAdminPage = () => (
  <AuthTemplate>
    <LoginStandard apiUrl={apiRoutes.login_admin} />
  </AuthTemplate>
);

export default LoginAdminPage;
